module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui container view"
  }, [_c('div', {
    staticClass: "ui grid"
  }, [_c('div', {
    staticClass: "two column row"
  }, [_c('div', {
    staticClass: "ten wide column"
  }, [_c('table', {
    staticClass: "ui celled definition table"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.quoteAggregates.components), function(component) {
    return _c('tr', {
      class: _vm.currentComponentClass(component.title)
    }, [_c('td', {
      staticClass: "collapsing"
    }, [_c('div', {
      staticClass: "ui fitted toggle checkbox"
    }, [_c('input', {
      staticClass: "hidden",
      attrs: {
        "type": "checkbox",
        "checked": "checked",
        "tabindex": "0"
      },
      on: {
        "change": function($event) {
          _vm.toggleComponent(component.title)
        }
      }
    })])]), _vm._v(" "), _c('td', {
      staticClass: "title"
    }, [_c('strong', [_vm._v(_vm._s(component.title))])]), _vm._v(" "), _c('td', {
      staticClass: "hours"
    }, [_vm._v(_vm._s(component.total_hours))]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm._f("currency")(component.total_hours * _vm.quoteParams.rate)))]), _vm._v(" "), _c('td', {
      staticClass: "amount"
    }, [_vm._v(_vm._s(_vm._f("currency")(component.total_hours * _vm.quoteParams.optionalRate)))])])
  })), _vm._v(" "), _c('tfoot', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    staticClass: "title"
  }, [_vm._v("Subtotal")]), _vm._v(" "), _c('th', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.componentsSumBy('hours')))]), _vm._v(" "), _c('th', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.componentsSumBy('hours') * _vm.quoteParams.rate)))]), _vm._v(" "), _c('th', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.componentsSumBy('hours') * _vm.quoteParams.optionalRate)))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "empty"
  }), _vm._v(" "), _c('th', {
    staticClass: "title"
  }, [_vm._v("Project Management")]), _vm._v(" "), _c('th', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.componentsSumBy('pm')))]), _vm._v(" "), _c('th', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.componentsSumBy('pm') * _vm.quoteParams.rate)))]), _vm._v(" "), _c('th', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.componentsSumBy('pm') * _vm.quoteParams.optionalRate)))])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "empty"
  }), _vm._v(" "), _c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Fixed Cost Items")]), _vm._v(" "), _c('th', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.fixedCostItemsAmount)))]), _vm._v(" "), _c('th', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.fixedCostItemsAmount)))])]), _vm._v(" "), _c('tr', {
    staticClass: "total"
  }, [_c('th', {
    staticClass: "empty"
  }), _vm._v(" "), _c('th', {
    staticClass: "title"
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.componentsSumBy('total_hours')))]), _vm._v(" "), _c('th', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")((_vm.componentsSumBy('total_hours') * _vm.quoteParams.rate) + _vm.fixedCostItemsAmount)))]), _vm._v(" "), _c('th', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")((_vm.componentsSumBy('total_hours') * _vm.quoteParams.optionalRate) + _vm.fixedCostItemsAmount)))])])])], 1), _vm._v(" "), _c('table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.quoteParams.showHosting),
      expression: "quoteParams.showHosting"
    }],
    staticClass: "ui blue celled table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Hosting")]), _vm._v(" "), _c('td', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.totalDevHours) + " hrs × " + _vm._s(_vm._f("currency")(_vm.quoteParams.newlineRate)) + " × " + _vm._s(_vm.quoteParams.hostingRatio) + "% + " + _vm._s(_vm._f("currency")(_vm.quoteParams.hostingBase)))]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalHostingAmount)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "title"
  }, [_vm._v("Support")]), _vm._v(" "), _c('td', {
    staticClass: "hours"
  }, [_vm._v(_vm._s(_vm.totalDevHours) + " hrs × " + _vm._s(_vm._f("currency")(_vm.quoteParams.newlineRate)) + " × " + _vm._s(_vm.quoteParams.supportRatio) + "% + " + _vm._s(_vm._f("currency")(_vm.quoteParams.supportBase)))]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalSupportAmount)))])])]), _vm._v(" "), _c('tfoot', [_c('tr', {
    staticClass: "total"
  }, [_c('th', {
    staticClass: "title",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('th', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.totalMonthlyServicesAmount)))])])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "six wide column"
  }, [_c('table', {
    staticClass: "ui red table"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Project Management Ratio")]), _vm._v(" "), _c('td', {
    staticClass: "param-input"
  }, [_c('div', {
    staticClass: "ui small fluid labeled input"
  }, [_c('label', {
    staticClass: "ui label"
  }, [_vm._v("%")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.quoteParams.pmRatio),
      expression: "quoteParams.pmRatio",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.quoteParams.pmRatio)
    },
    on: {
      "change": _vm.updatePmRatio,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quoteParams.pmRatio = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Hourly Rate")]), _vm._v(" "), _c('td', {
    staticClass: "param-input"
  }, [_c('div', {
    staticClass: "ui small fluid labeled input"
  }, [_c('label', {
    staticClass: "ui label"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.quoteParams.rate),
      expression: "quoteParams.rate",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.quoteParams.rate)
    },
    on: {
      "change": _vm.updateQuoteParams,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quoteParams.rate = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Optional Hourly Rate")]), _vm._v(" "), _c('td', {
    staticClass: "param-input"
  }, [_c('div', {
    staticClass: "ui small fluid labeled input"
  }, [_c('label', {
    staticClass: "ui label"
  }, [_vm._v("$")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.quoteParams.optionalRate),
      expression: "quoteParams.optionalRate",
      modifiers: {
        "number": true
      }
    }],
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.quoteParams.optionalRate)
    },
    on: {
      "change": _vm.updateOptionalRate,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quoteParams.optionalRate = _vm._n($event.target.value)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Show Monthly Recurring Services")]), _vm._v(" "), _c('td', {
    staticClass: "param-input"
  }, [_c('div', {
    staticClass: "ui toggle checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quoteParams.showHosting),
      expression: "quoteParams.showHosting"
    }],
    staticClass: "hidden",
    attrs: {
      "type": "checkbox",
      "tabindex": "0"
    },
    domProps: {
      "checked": Array.isArray(_vm.quoteParams.showHosting) ? _vm._i(_vm.quoteParams.showHosting, null) > -1 : (_vm.quoteParams.showHosting)
    },
    on: {
      "change": _vm.toggleShowHosting,
      "click": function($event) {
        var $$a = _vm.quoteParams.showHosting,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$c) {
            $$i < 0 && (_vm.quoteParams.showHosting = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.quoteParams.showHosting = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.quoteParams.showHosting = $$c
        }
      }
    }
  })])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th'), _vm._v(" "), _c('th', {
    attrs: {
      "colspan": "4"
    }
  }, [_vm._v("Estimate Breakdown")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Monthly Recurring Services")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Estimate Parameters")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-faf071ac!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/Dashboard.vue
// module id = 228
// module chunks = 2